import React, { useEffect, useState } from 'react';
import ZonaD from './ZonaD'
import Navbar2 from './Navbar'
import defaultImagen from '../assets/zonaDescarga.jpg'

const api = process.env.REACT_APP_API;

function Zonadescarga() {
    const cards=[
        {
            id:24,
            Nombre:'Zona de Descarga',
            Edificio:'Torre 2',
            N_piso:'No aplica',
            Tamaño:'Grande',
            N_personas:'10',
            Estado:'Disponible',
            img:defaultImagen,
            img2:defaultImagen

        }
    ]

    const [estadoPorId, setEstadoPorId] = useState({});

    useEffect(() => {
        const cargarEstados = async () => {
            try {
                const res = await fetch(`${api}/salas`);
                const data = await res.json();
                const mapa = {};
                (Array.isArray(data) ? data : []).forEach((s) => {
                    mapa[s.id_Sala] = String(s.estado || "Disponible").trim();
                });
                setEstadoPorId(mapa);
            } catch (e) {
                console.error(e);
            }
        };
        cargarEstados();
    }, []);


  return <div>
    <Navbar2/>
    <div className='container d-flex'>
      <div className='container col-md-12 p-2 '>
            <div className='row col-md-12 d-flex justify-content-center align-items-center'>
            {
                  cards.map(card=>{
                    const estado = estadoPorId[card.id] ?? card.Estado;
                    return (
                    <div className="col-md-10" key={card.id}>
                    <ZonaD id={card.id} Nombre={card.Nombre} Edificio={card.Edificio} N_piso={card.N_piso} Tamaño={card.Tamaño} N_personas={card.N_personas} Estado={estado} img={card.img} img2={card.img2} ></ZonaD>
                    </div>
                    );
                  })
              }

            </div>
      </div>

  </div>
  </div>
}

export default Zonadescarga;
